import AddIcon from '@mui/icons-material/Add';
import DeleteIconButton from '../components/DeleteIconButton';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Switch, TextField, Tooltip, Typography } from '@mui/material';
import grey from '@mui/material/colors/grey';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import * as React from 'react';
import { useHistory, useParams } from 'react-router';
import { useTheme } from '@mui/material';

import { CREATE, DataAPIContext, DELETE, GET_ONE, UPDATE } from '../api';
import AccessDeniedView from '../components/AccessDeniedView';
import AccessTagsDropdown from '../components/AccessTagsDropdown';
import BlockRedirect from '../components/BlockRedirect';
import ConfirmationDialog from '../components/ConfirmationDialog';
import FixedLinearProgress from '../components/FixedLinearProgress';
import FormActionButtons from '../components/FormActionButtons';
import FormLicenseeContext, { toLicenseeId } from '../components/FormLicenseeContext';
import LicenseeFormField from '../components/LicenseeFormField';
import NavigateBackBar from '../components/NavigateBackBar';
import PageMeta from '../components/PageMeta';
import RecordDetails, { RecordDetailsContext } from '../components/RecordDetails';
import RemoteAutocomplete from '../components/RemoteAutocomplete';
import { TOUR_TAG_PICKER_PAGING } from '../components/tourTagPickerPaging';
import RevisionHistoryDialog from '../components/RevisionHistoryDialog';
import { ContextStore } from '../store/contextStore';
import { useIsWidthUp } from '../utils';
import DeliveryMethodList from './DeliveryMethodList';
import NotificationAdvancedRule from './NotificationAdvancedRule';
import NotificationLoading from './NotificationLoading';
import NotificationRule from './NotificationRule';
import { computeRuleIssues, issuesForRule, serverRuleIssues, useRuleSchema } from './ruleValidation';
import { CONDITION_ANY, ConfirmationDialogText, DELIVERY_ADVANCED, DELIVERY_METHOD_SUCCESSFUL, eventOptions, EVENTS,
    NON_ADMIN_DELIVERY_METHODS, RULES_MATCH_ALL, RULES_MATCH_ANY, notificationReactionOptions, LOCK_NONE, LOCK_USER, bookingStatesMenuItems
    // DELIVERY_ALL, DELIVERY_FIRST, DELIVERY_METHOD_CHAT,
    // DELIVERY_METHOD_CHAT_DESTINATION, DELIVERY_METHOD_EMAIL, DELIVERY_METHOD_EMAIL_DESTINATION, DELIVERY_METHOD_READ,
    // DELIVERY_METHOD_SMS, DELIVERY_METHOD_SMS_DESTINATION, DELIVERY_METHOD_UNREAD,
    // DELIVERY_METHOD_UNSUCCESSFUL, DELIVERY_METHOD_WHATSAPP, DELIVERY_METHOD_WHATSAPP_DESTINATION, DELIVERY_METHODS,
    // DELIVERY_ORDERING, deliveryMethodsOptions, EMAIL_TO_ADDRESS, EMAIL_TO_SUPPORT, eventsHtmlOptions,
    // language_iso_codes, NOTIFICATION_REACTIONS, opsHtmlOptions,
    // opsOptions, RULES_MATCH_TYPES, ruleTemplatesHtmlOptions,
    // SMS_TO_NUMBER, SMS_TO_SUPPORT, TOUR_OVERRIDE_MODES, TOUR_PARTICIPANT_HAS_TAG, TOUR_PARTICIPANT_HAS_TAG_CATEGORY,
    // TOUR_PARTICIPANT_IS_FIELD_AFFECTED, TOUR_PARTICIPANT_IS_UPDATED_VIA, TOUR_PARTICIPANT_SOURCES, TOUR_PARTICIPANT_SURVEY,
    // TOUR_PARTICIPANT_SURVEY_STATE, TOUR_PARTICIPANT_SURVEY_STATES, USER_COUNTRY, USER_LANGUAGE, USER_LOGGED_IN,
    // USER_REGISTERED_VIA_OTA, WHATSAPP_TO_NUMBER, WHATSAPP_TO_SUPPORT
    } from './utils';
import SystemTagsDropdown from '../components/SystemTagsDropdown';

const useStyles = makeStyles((theme) => ({
    root: {
        height: `calc(${theme.cp.contentHeight} - 0.25rem)`,
        overflowY: 'auto',
        [theme.breakpoints.down('sm')]: {
            height: `calc(${theme.cp.contentHeight} - 3.5rem)`,
        },
    },
    tabButton: {
        borderRadius: '30px',
        textTransform: 'capitalize',
        fontWeight: 'normal',
    },
    buttonPanel: {
        height: '44px !important',
        backgroundColor: grey[100],
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        padding: '12px 28px !important',
        justifyContent: 'space-between',
    },
}));

const compareIdx = (a, b) => {
    if (a.idx < b.idx) {
        return -1;
    }
    if (a.idx > b.idx) {
        return 1;
    }
    return 0;
};

const validateInput = (notification) => {
    const errors = {};
    let canSave = true;
    if (notification && (!notification.name || notification.name.length <= 0)) {
        if (notification._changed) {
            errors.name = { error: true, helperText: 'Name is required' };
        }
        canSave = false;
    }
    if(notification?.auto_replies?.options?.length > 0){
        for (let i = 0; i < notification.auto_replies.options.length; i++) {
            if (!notification.auto_replies.options[i].answer_trigger){// || !notification.auto_replies.options[i].auto_response) {
                canSave = false;
                errors.options = { error: true, helperText: 'Required' }
                break;
            }
        }
    }

    return { canSave, errors };
};

const getComparableState = (notification) => {
    const a = {
        ...notification,
    };
    delete a._changed;
    //console.log("Auto replies", JSON.stringify(a.auto_replies))
    return JSON.stringify(a);
};

const UserReaction = (props) => {
    const reaction = props.data;
    const tdHours = React.useRef(null);
    const tdMinutes = React.useRef(null);
    const disabled = props.disabled
    const timedelta = {
        hours: reaction && reaction.timedelta ? Math.floor(Math.abs(+reaction.timedelta) / 3600) : 0,
        minutes: reaction && reaction.timedelta ? Math.floor((Math.abs(+reaction.timedelta) % 3600) / 60) : 0,
        sign: reaction && reaction.timedelta ? +reaction.timedelta / Math.abs(reaction.timedelta) : 1,
    };
    const onTimedeltaChange = (ev) => {
        const hours = tdHours?.current?.value;
        const minutes = tdMinutes?.current?.value;
        const sign = reaction.timedelta >= 0 ? 1 : -1;

        props.setNotification((prev) => {
            let notification_reactions = [...prev.user_reactions];
            let selected_reaction = [...notification_reactions.filter((ur) => ur.idx === reaction.idx)][0];
            selected_reaction.timedelta = sign * (hours * 3600 + minutes * 60);
            notification_reactions = notification_reactions.filter((ur) => ur.idx !== reaction.idx);
            return {
                ...prev,
                user_reactions: [...notification_reactions, selected_reaction],
            };
        });
    };

    const onTimedeltaBeforeAfterChange = (selected_value) => {
        const hours = tdHours?.current?.value;
        const minutes = tdMinutes?.current?.value;
        const isAfter = selected_value === 'after';
        const sign = isAfter ? 1 : -1;

        props.setNotification((prev) => {
            let notification_reactions = [...prev.user_reactions];
            let selected_reaction = [...notification_reactions.filter((ur) => ur.idx === reaction.idx)][0];
            selected_reaction.timedelta = sign * (hours * 3600 + minutes * 60);
            notification_reactions = notification_reactions.filter((ur) => ur.idx !== reaction.idx);
            return {
                ...prev,
                user_reactions: [...notification_reactions, selected_reaction],
            };
        });
    };

    const onReactionChange = (ev) => {
        props.setNotification((prev) => {
            let notification_reactions = [...prev.user_reactions];
            let selected_reaction = [...notification_reactions.filter((ur) => ur.idx === reaction.idx)][0];
            selected_reaction.reaction = parseInt(ev.target.value);
            notification_reactions = notification_reactions.filter((ur) => ur.idx !== reaction.idx);

            return {
                ...prev,
                user_reactions: [...notification_reactions, selected_reaction],
            };
        });
    };

    return (
        <Grid container spacing={2} p={1} alignItems="center">
            <Grid item xs={12} sm={4}>
                <FormControl fullWidth disabled={disabled}>
                    <InputLabel style={{ marginTop: '1rem' }} id="reaction">
                        User behavior:
                    </InputLabel>
                    <Select onChange={onReactionChange} name="reaction" labelId="reaction" size="small" label="User behavior:" variant="filled" native value={reaction.reaction}>
                        {notificationReactionOptions}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={2} container alignItems="center">
                <TextField disabled={disabled} inputRef={tdHours} name="hours" label="Hours" variant="filled" size="small" value={timedelta.hours} onChange={onTimedeltaChange} fullWidth />
            </Grid>
            <Grid item xs={6} sm={2} md={2} container alignItems="center">
                <TextField disabled={disabled} inputRef={tdMinutes} name="minutes" label="Minutes" variant="filled" size="small" value={timedelta.minutes} onChange={onTimedeltaChange} fullWidth />
            </Grid>
            <Grid item xs={8} sm={3} md={2} lg={'auto'} container alignItems="center">
                <FormControl disabled={disabled}>
                    <FormLabel id="time-delta-radio">Time to event</FormLabel>
                    <RadioGroup row aria-labelledby="time-delta-radio" name="row-radio-buttons-group" onChange={(ev, selected_value) => onTimedeltaBeforeAfterChange(selected_value)}>
                        <FormControlLabel value="before" control={<Radio checked={reaction && reaction.timedelta < 0} />} label="Before" />
                        <FormControlLabel value="after" control={<Radio checked={reaction && reaction.timedelta >= 0} />} label="After" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={2} sm={1} container justifyContent="flex-start" alignItems="center" style={{ paddingTop: '1.25rem' }}>
                <DeleteIconButton title="Delete reaction" size="medium" fontSize="medium" disabled={props.disableSaveButton || disabled} onClick={() => props.handleRemoveReaction(reaction.idx)} />
            </Grid>
        </Grid>
    );
};

const ResponseHandlerOption = (props) => {
    const disabled = props.disabled
    const auto_reply = props.notification?.auto_replies
    const answer = React.useRef(null);
    const tag = React.useRef(null);
    const response = React.useRef(null);
    const auto_reply_option = props.data;
    const [answerHasBeenBlurred, setAnswerHasBeenBlurred] = React.useState(false);
    const [, setReplyHasBeenBlurred] = React.useState(false);

    const onAutoReplyOptionChange = (ev, selected_tag) => {
        props.setNotification((prev) => {
            const ans = answer?.current?.value;
            const resp = response?.current?.value;

            let auto_replies = [...prev.auto_replies?.options];
            let selected_auto_reply = [...auto_replies.filter((ur) => ur.idx === auto_reply_option.idx)][0];

            selected_auto_reply.answer_trigger = ans;
            if (selected_tag !== undefined) {
                selected_auto_reply.tag = selected_tag;
            }
            selected_auto_reply.auto_response = resp;

            auto_replies = auto_replies.filter((ur) => ur.idx !== auto_reply_option.idx);

            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    options: [...auto_replies, selected_auto_reply]
                },
            };

        });
    };

    const onUseAIChange = (ev, selectedVal) => {
        props.setNotification((prev) => {
            let auto_replies = [...prev.auto_replies?.options];
            let selected_auto_reply = [...auto_replies.filter((ur) => ur.idx === auto_reply_option.idx)][0];

            selected_auto_reply.answer_trigger_is_ai_prompt = selectedVal;

            auto_replies = auto_replies.filter((ur) => ur.idx !== auto_reply_option.idx);

            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    options: [...auto_replies, selected_auto_reply]
                },
            };

        });
    };

    return (
        <Grid container spacing={2} p={1} alignItems="center" style={{marginBottom:"8px"}}>
            {auto_reply_option?.idx === 0 ?
            <Grid item xs={12}>
                 If user replies:
            </Grid>
            : ""}
            <Grid item sm={.7} style={{ fontSize: ".85rem", marginRight: "-1rem"}}>
                <FormControlLabel disabled={props.disabled} control={<Checkbox checked={auto_reply_option?.answer_trigger_is_ai_prompt} onChange={onUseAIChange} size="small" />} label={<Typography style={{ fontSize: ".65rem" }}>Use AI</Typography>} />
            </Grid>
            <Grid item xs={12} sm={2.3}>
                <TextField
                    {...(!auto_reply_option?.answer_trigger?.trim() && answerHasBeenBlurred ? { ...props.errors.options } : {})}
                    value={auto_reply_option?.answer_trigger}
                    inputRef={answer}
                    disabled={disabled}
                    onChange={onAutoReplyOptionChange}
                    onBlur={()=>setAnswerHasBeenBlurred(true)}
                    name="answer"
                    label={!auto_reply_option?.answer_trigger_is_ai_prompt ? "Answer:" : "AI Prompt"}
                    variant="filled"
                    size="small"
                    fullWidth
                    multiline
                    FormHelperTextProps={{ style: { marginBottom: '-22px' }}}
                />
            </Grid>

            <Grid item xs={12} sm={3.5}>
                <FormControl fullWidth disabled={disabled}>
                    <RemoteAutocomplete
                        inputRef={tag}
                        disabled={disabled}
                        name={'tag'}
                        resource="tour_tag"
                        label="Apply Tag (Optional)"
                        variant="filled"
                        size="small"
                        urlSuffix={null}
                        onChange={onAutoReplyOptionChange}
                        {...TOUR_TAG_PICKER_PAGING}
                        defaultValue={auto_reply_option.tag}
                        getOptionLabel={(opt) => `${opt.category}: ${opt.name}`}
                        filterOptions={(optlist) => optlist}
                        mapResults={(optlist, res) => optlist.map((x) => ({ id: x.id, name: x.name, category: x.category.code }))}
                        searchCharsToIgnore={[':']}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={5.0} container alignItems="center">
                <TextField
                    value={auto_reply_option?.auto_response}
                    inputRef={response}
                    onChange={onAutoReplyOptionChange}
                    onBlur={()=>setReplyHasBeenBlurred(true)}
                    disabled={disabled}
                    name="replywith"
                    label="Reply with:"
                    variant="filled"
                    size="small"
                    fullWidth
                    multiline
                />
            </Grid>
            <Grid item justifyContent="flex-start" alignItems="center" style={{width: "20px", paddingLeft: "4px"}}>
                {auto_reply_option?.idx < auto_reply.options.length - 1 ?
                <Tooltip title="Move down">
                    <span>
                        <IconButton disabled={disabled} onClick={() => props.handleMoveReplyOptionDown(auto_reply_option?.idx)}>
                            <ArrowDownwardIcon style={{ color: '#747475', cursor: 'pointer' }} />
                        </IconButton>
                    </span>
                </Tooltip> : ""}
            </Grid>
            <Grid item justifyContent="flex-start" alignItems="center" style={{width: "20px", paddingLeft: "16px"}}>
                {!auto_reply.enabled || auto_reply.options.length > 1 ?
                <DeleteIconButton title="Delete option" size="medium" fontSize="medium" disabled={disabled} onClick={() => props.handleRemoveReplyOption(auto_reply_option?.idx)} /> : ""}
            </Grid>
        </Grid>
    );
};

const ResponseHandler = (props) => {
    const reply = props.notification?.auto_replies;
    const tdHours = React.useRef(null);
    const tdMinutes = React.useRef(null);
    const [replyExpires, setReplyExpires] = React.useState(reply?.timedelta_before_tour_start_to_expire_reply != null);
    const [showSendAnotherMessage, setShowSendAnotherMessage] = React.useState(props.notification?.auto_replies?.enabled || false);

    const disabled = props.disabled
    const timedelta = {
        hours: reply && reply.timedelta_before_tour_start_to_expire_reply ? Math.floor(Math.abs(reply.timedelta_before_tour_start_to_expire_reply) / 3600) : 0,
        minutes: reply && reply.timedelta_before_tour_start_to_expire_reply ? Math.floor((Math.abs(reply.timedelta_before_tour_start_to_expire_reply) % 3600) / 60) : 0,
        sign: reply && reply.timedelta_before_tour_start_to_expire_reply && reply.timedelta_before_tour_start_to_expire_reply < 0 ? -1 : 1,
    };
    const onReplyExpireTimedeltaChange = (ev) => {
        const hours = tdHours?.current?.value;
        const minutes = tdMinutes?.current?.value;
        const sign = props.notification.auto_replies?.timedelta_before_tour_start_to_expire_reply >= 0 ? 1 : -1;

        props.setNotification((prev) => {
            const td = sign * (hours * 3600 + minutes * 60)
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    timedelta_before_tour_start_to_expire_reply: td
                },
            };
        });
    };

    const onReplyExpireTimedeltaBeforeAfterChange = (selected_value) => {
        const hours = tdHours?.current?.value;
        const minutes = tdMinutes?.current?.value;
        const isBefore = selected_value === 'before';
        const sign = isBefore ? 1 : -1;

        props.setNotification((prev) => {
            const td = replyExpires ? sign * (hours * 3600 + minutes * 60) : null;
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    timedelta_before_tour_start_to_expire_reply: td
                },
            };
        });
    };


    const handleAddReplyOption = () => {
        props.setNotification((prev) => {
            const idx = prev.auto_replies?.options?.length || 0;
            const options = prev.auto_replies?.options || []
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    options: [...options, { idx: idx, sequence: idx, answer_trigger: "", tag: null, auto_response: "" }]
                },
            };
        });
    };

    const handleRemoveReplyOption = (idx) => {
        props.setNotification((prev) => {
            let new_idx_replies = prev.auto_replies?.options.filter((ur) => ur.idx !== idx);
            if (new_idx_replies.length > 0) {
                for (let index = 0; index < new_idx_replies.length; index++) {
                    new_idx_replies[index].idx = new_idx_replies[index].sequence = index;
                }
            }
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    options: new_idx_replies
                }
            };
        });
    };

    const handleMoveReplyOptionDown = (idx) => {
        props.setNotification((prev) => {
            let new_idx_replies = prev.auto_replies?.options
            if (new_idx_replies.length > 1 && idx < new_idx_replies.length - 1) {
                new_idx_replies[idx].idx = new_idx_replies[idx].sequence = idx + 1
                new_idx_replies[idx + 1].idx = new_idx_replies[idx + 1].sequence = idx
            }
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    options: new_idx_replies
                }
            };
        });
    };

    const onToggleReplyEnabled = () => {
        const enabled = !showSendAnotherMessage;

        if(enabled && (!reply?.options || reply?.options?.length < 1)){
            handleAddReplyOption()
        }

        props.setNotification((prev) => {
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    enabled: enabled
                },
            };
        });

        setShowSendAnotherMessage(enabled);
    };

    const onToggleMarkAnswersAsRead = (ev) => {
        props.setNotification((prev) => {
            return {
                ...prev,
                auto_replies: {
                    ...prev.auto_replies,
                    mark_answers_as_read: ev.target.checked
                },
            };
        });
    };


    React.useEffect(() => {
        const before_after = reply?.timedelta_before_tour_start_to_expire_reply >= 0 ? "before" : "after"
        if(props.notification.auto_replies){
            onReplyExpireTimedeltaBeforeAfterChange(before_after)
        }
    }, [replyExpires]);

    return (
        <Grid item xs={12} container>
            <Grid item xs={12} container paddingBottom={1} paddingTop={1}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={showSendAnotherMessage}
                        onChange={onToggleReplyEnabled}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                    label={<Typography sx={{ fontWeight: '400' }}>Send another message</Typography>}
                />
            </Grid>
            {showSendAnotherMessage && (
                <Grid item xs={12}>
                    {props.notification.auto_replies?.options?.sort(compareIdx).map((ur) => {
                        return (
                            <Grid item xs={12} container alignItems="center">
                                <ResponseHandlerOption
                                    disabled={disabled}
                                    data={ur}
                                    disableDeleteButton={props.notification.auto_replies?.options?.filter((ur) => ur.created).length > 0 && !ur.created}
                                    key={ur.idx}
                                    notification={props.notification}
                                    setNotification={props.setNotification}
                                    isSmallScreen={props.isSmallScreen}
                                    handleRemoveReplyOption={handleRemoveReplyOption}
                                    handleMoveReplyOptionDown={handleMoveReplyOptionDown}
                                    errors={props.errors}
                                />
                            </Grid>
                        );
                    })}
                    <Grid item xs={12} container justifyContent="flex-start" style={{marginLeft: "4em", marginTop:"12px", marginBottom:6}}>
                        <Button disabled={disabled} onClick={handleAddReplyOption} variant="outlined" color="primary">
                            <AddIcon fontSize="small"/>&nbsp;Add a reply
                        </Button>
                    </Grid>
                    {props.notification.auto_replies?.options?.length > 0 && (
                        <>
                            <Grid item xs={12} style={{ fontSize: ".85rem", marginLeft: "4.7em" }}>
                                <FormControlLabel
                                    disabled={props.disabled}
                                    control={<Checkbox checked={props.notification.auto_replies?.mark_answers_as_read} onChange={onToggleMarkAnswersAsRead} size="small" />}
                                    label={<Typography style={{ fontSize: ".85rem" }}>Mark conversation as read upon user reply</Typography>}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ fontSize: ".85rem", marginLeft: "1em" }}>
                                <FormControlLabel
                                    disabled={props.disabled}
                                    control={<Checkbox checked={replyExpires} onChange={() => {setReplyExpires(!replyExpires)}} size="small" />}
                                    label={<Typography style={{ fontSize: ".85rem" }}>Reply expires</Typography>}
                                />
                            </Grid>
                            {replyExpires && (
                                <Grid item style={{marginLeft: "0em"}}  xs={12} spacing={2} container justifyContent="flex-start">
                                    <Grid item xs={12} sm={4} md={2} lg={2}>
                                        <TextField disabled={disabled} inputRef={tdHours} defaultValue={timedelta.hours} label="Hours" variant="filled" size="small" fullWidth onChange={onReplyExpireTimedeltaChange} />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={2} lg={2}>
                                        <TextField disabled={disabled} inputRef={tdMinutes} defaultValue={timedelta.minutes} label="Minutes" variant="filled" size="small" fullWidth onChange={onReplyExpireTimedeltaChange}/>
                                    </Grid>
                                    <Grid item xs={12} md={8} lg={'auto'} container alignItems="center">
                                        <FormControl disabled={disabled}>
                                            <RadioGroup row aria-labelledby="time-delta-radio" name="row-radio-buttons-group" onChange={(ev, selected_value) => onReplyExpireTimedeltaBeforeAfterChange(selected_value)}>
                                                <FormControlLabel value="before" control={<Radio checked={(props.notification.auto_replies?.timedelta_before_tour_start_to_expire_reply || 0) >= 0} />} label="Before the tour starts" />
                                                <FormControlLabel value="after" disabled={(props.notification.auto_replies?.timedelta_before_tour_start_to_expire_reply || 0) == 0} control={<Radio checked={props.notification.auto_replies?.timedelta_before_tour_start_to_expire_reply < 0} />} label="After the tour starts" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            )}
                        </>
                    )}
                </Grid>
            )}
        </Grid>
    );
};

const GuestRoleUniqId = Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));

const addIdxToReactionsAndRules = (props) => {
    let notification_data = props.data;
    let user_reactions_data = notification_data.user_reactions;
    let auto_replies_data = notification_data.auto_replies;
    let notification_rules_data = notification_data.rules;
    let notification_adv_rules_data = notification_data.delivery_method_advanced_rules;
    let delivery_methods_data = notification_data.delivery_methods;

    for (let index = 0; index < user_reactions_data.length; index++) {
        user_reactions_data[index].idx = index;
    }

    for (let index = 0; index < auto_replies_data?.options?.length; index++) {
        auto_replies_data.options[index].idx = auto_replies_data.options[index].sequence;
    }

    for (let index = 0; index < notification_rules_data.length; index++) {
        notification_rules_data[index].idx = index;
    }

    for (let index = 0; index < notification_adv_rules_data.length; index++) {
        notification_adv_rules_data[index].idx = index;
    }

    for(let index = 0; index < delivery_methods_data.length; index++){
        if(!delivery_methods_data[index].option_str){
            delivery_methods_data[index].option_str = "Option " + String.fromCharCode('A'.charCodeAt(0) + index);
        }
    }

    //Add roles to roles array based on notification flags
    let notification_roles = [...notification_data.roles];
    if (notification_data.apply_to_guests) {
        notification_roles = [...notification_roles, GuestRoleUniqId];
    }

    return {
        ...props.data,
        user_reactions: user_reactions_data,
        auto_replies: auto_replies_data,
        rules: notification_rules_data,
        roles: notification_roles,
        delivery_method_advanced_rules: notification_adv_rules_data,
        delivery_methods: delivery_methods_data
    };
};

const NotificationEditForm = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const resource = 'notification';
    const urlParams = useParams();
    const theme = useTheme();
    const { user, roleMap, hasPerm } = React.useContext(ContextStore);

    const role_map = {
        ...roleMap,
        [GuestRoleUniqId]: { id: GuestRoleUniqId, name: 'Guest' },
    };
    const classes = useStyles();
    const [syncActive, setSyncActive] = React.useState(false);
    const [, setServerErrors] = React.useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [notification, setNotification] = React.useState(() => addIdxToReactionsAndRules(props) || {});
    const [customEvent, setCustomEvent] = React.useState(notification && notification.event && Object.keys(EVENTS).indexOf(notification.event) < 0);
    const isSmallScreen = !useIsWidthUp('sm');
    const [showAdvancedSettings, setShowAdvancedSettings] = React.useState(notification?.user_reactions?.length > 0 || notification?.rules?.length > 0 || notification?.auto_replies?.options?.length > 0);

    const [confirmationDialogAction, setConfirmationDialogAction] = React.useState(null);
    const mounted = React.useRef(null);
    const history = useHistory();
    const [relatedLoading, setRelatedLoading] = React.useState(null);
    const [openChangeHistory, setOpenChangeHistory] = React.useState(false);

    const [originalState, setOriginalState] = React.useState(getComparableState(addIdxToReactionsAndRules(props)));
    const currentState = getComparableState(notification);
    const isChanged = originalState !== currentState;

    // Rule validation against the backend's rule-args schema: issues on new or
    // changed rules block the save (the server would answer 406), issues on rules
    // saved unchanged only warn. `baselineRules` is the last loaded/saved list (a
    // deep copy — the rule handlers edit rule objects in place).
    const [baselineRules, setBaselineRules] = React.useState(() => JSON.parse(JSON.stringify((props.data && props.data.rules) || [])));
    const ruleSchema = useRuleSchema();
    const ruleIssues = React.useMemo(
        () => computeRuleIssues(ruleSchema, notification.rules || [], baselineRules),
        [ruleSchema, notification.rules, baselineRules],
    );
    const [serverRuleErrors, setServerRuleErrors] = React.useState({ byIdx: {}, rulesKey: null });
    const rulesKey = JSON.stringify(notification.rules || []);
    const shownServerRuleErrors = serverRuleErrors.rulesKey === rulesKey ? serverRuleErrors.byIdx : {};

    const isCreate = !urlParams.id;
    const isAdmin = user.email.indexOf('@curatedplanet.com') > 0;

    const isTourParticipantEvent = notification && notification.event && notification.event.indexOf && notification.event.indexOf("tour_participant.") === 0;
    const isOrderEvent = notification && notification.event && notification.event.indexOf && notification.event.indexOf("order.") === 0;

    const hasWritePerm = hasPerm('notification', 'write')

    const onLicenseeChange = (id) => {
        setNotification((prev) => ({ ...prev, tour_operator: id, _changed: true }));
    };

    const page_title_length = isSmallScreen ? 40 : 120;
    const { canSave, errors } = validateInput(notification);
    const role_options = Object.keys(role_map).map((role) => {
        return role_map[role];
    });

    const onSelectChange = (ev) => {
        setNotification((prevState) => ({
            ...notification,
            [ev.target.name]: ev.target.value,
        }));
    };

    const onTextChange = (ev) => {
        setNotification((prevState) => ({
            ...notification,
            [ev.target.name]: ev.target.value,
        }));
    };

    React.useEffect(() => {
        if (urlParams.id && (!notification || !notification.id)) {
            setSyncActive(true);
            dataAPI(GET_ONE, resource, { id: urlParams.id })
                .then((res) => {
                    console.log('get one', urlParams.id, res);
                    setNotification(res.data);
                })
                .finally(() => setSyncActive(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlParams.id]);

    const handleSave = (newState) => {
        let new_data = newState ? { ...newState } : notification;
        if (ruleIssues.blocking) {
            enqueueSnackbar('Fix the rules marked in red before saving.', { variant: 'error' });
            return;
        }

        //Remove temporary id required by the dataGrid from the newly created delivery methods
        let notification_delivery_methods = [...new_data.delivery_methods];

        // Copies, never in-place deletes: the editor keeps these rows (and their
        // temporary ids) when the save is rejected.
        notification_delivery_methods = [
            ...notification_delivery_methods.map((dm) => {
                if (dm.created) {
                    const { id: _id, name: _name, created: _created, ...rest } = dm;
                    return rest;
                }
                return dm;
            }),
        ];

        //Remove random Generated guest ID needed for the the autocomplete component
        let triggered_by_roles = new_data.roles.filter((role) => role !== GuestRoleUniqId);
        // Copies without `idx` — deleting it from the live rule objects broke
        // onUpdateRule (it matches rows by idx) as soon as a save was rejected.
        const sentRules = new_data.rules || [];
        let notification_rules = sentRules.map(({ idx: _idx, ...rule }) => rule);

        let updated_notification = { ...new_data };
        updated_notification.delivery_methods = notification_delivery_methods;
        updated_notification.roles = triggered_by_roles;
        updated_notification.rules = notification_rules;

        setSyncActive(true);
        setRelatedLoading(true);
        (async () => {
            try {
                const res = await dataAPI(UPDATE, resource, {
                    id: new_data.id,
                    data: updated_notification,
                });
                console.log('update', res);
                if (res.statusCode === 200 || res.statusCode === 201) {
                    enqueueSnackbar('Notification saved', { variant: 'success' });
                    // rule_warnings (legacy rules saved unchanged) are recomputed client-side.
                    if (res.data && res.data.rule_warnings) {
                        delete res.data.rule_warnings;
                    }
                    setBaselineRules(JSON.parse(JSON.stringify((res.data && res.data.rules) || [])));
                    setServerRuleErrors({ byIdx: {}, rulesKey: null });
                    let notification_roles = [...new_data.roles];
                    if (res.data.apply_to_guests && new_data.roles.filter((role) => role === GuestRoleUniqId).length === 0) {
                        notification_roles = [...notification_roles, GuestRoleUniqId];
                    }
                    if (res.data.apply_to_guests) {
                        setNotification((prev) => ({
                            ...res.data,
                            roles: notification_roles,
                        }));
                        addIdxToReactionsAndRules(res);
                        setOriginalState(getComparableState({ ...res.data, roles: notification_roles }));
                    } else {
                        setNotification(res.data);
                        addIdxToReactionsAndRules(res);
                        setOriginalState(getComparableState(res.data));
                    }
                } else if (res.statusCode === 406) {
                    const ruleErrors = serverRuleIssues(res.data?.errors, sentRules);
                    if (Object.keys(ruleErrors).length) {
                        setServerRuleErrors({ byIdx: ruleErrors, rulesKey: JSON.stringify(sentRules) });
                    }
                    if (res.data?.message) {
                        enqueueSnackbar(res.data.message, { variant: 'error' });
                    } else {
                        enqueueSnackbar('Notification validation error', {
                            variant: 'warning',
                        });
                        console.log('validation errors', res.data);
                        setServerErrors(res.data.errors);
                    }
                }
            } finally {
                if (mounted.current) {
                    setSyncActive(false);
                }
                setSyncActive(false);
                setRelatedLoading(false);
            }
        })();
    };

    const doDelete = (ev) => {
        props.onDelete && props.onDelete(props.data);
        setSyncActive(true);
        (async () => {
            try {
                const res = await dataAPI(DELETE, props.resource, {
                    id: notification.id,
                });
                enqueueSnackbar('Notification  deleted', { variant: 'default' });
                console.log('delete', res);
                history.push(`/notifications/`);
            } catch (e) {
                console.log('error deleting Notification', e);
                enqueueSnackbar('Error deleting Notification', { variant: 'error' });
            } finally {
                setSyncActive(false);
            }
        })();
    };

    const handleDelete = (ev) => {
        setConfirmationDialogAction('delete_notification');
    };

    const backUrl = props.lastTabSelected?.name ? ('/notifications?tab=' + props.lastTabSelected.name) : '/notifications';

    // CP-8423: back to the notifications list, same target as the NavigateBackBar
    // arrow; BlockRedirect still guards unsaved changes.
    const handleCancel = () => {
        history.push(backUrl);
    };

    const confirmationDialogCancel = () => {
        setConfirmationDialogAction(null);
    };
    const confirmationDialogConfirm = () => {
        switch (confirmationDialogAction) {
            case 'delete_notification':
            case 'delete_notifications':
                doDelete();
                break;
            default:
                break;
        }
        confirmationDialogCancel();
    };

    const handleAddReaction = () => {
        setNotification((prev) => {
            let idx = prev.user_reactions?.length;
            return {
                ...prev,
                user_reactions: [...prev.user_reactions, { idx: idx, reaction: 0, enabled: true, timedelta: 0 }],
            };
        });
    };

    const handleRemoveReaction = (idx) => {
        setNotification((prev) => {
            let new_idx_reactions = prev.user_reactions.filter((ur) => ur.idx !== idx);
            if (new_idx_reactions.length > 0) {
                for (let index = 0; index < new_idx_reactions.length; index++) {
                    new_idx_reactions[index].idx = index;
                }
            }
            return { ...prev, user_reactions: [...new_idx_reactions] };
        });
    };

    const handleRolesChange = (ev, roles) => {
        let formatted_roles = roles.map((r) => r.id);

        if (roles.filter((role) => role.id === 78).length > 0 && roles.filter((role) => parseInt(role.id) === parseInt(GuestRoleUniqId)).length > 0) {
            //support observer
            setNotification((prev) => ({
                ...prev,
                roles: formatted_roles,
                apply_to_observers: true,
                apply_to_guests: true,
            }));
            return;
        }

        if (roles.filter((role) => role.id === 78).length > 0 && roles.filter((role) => parseInt(role.id) === parseInt(GuestRoleUniqId)).length === 0) {
            //support observer
            setNotification((prev) => ({
                ...prev,
                roles: formatted_roles,
                apply_to_observers: true,
                apply_to_guests: false,
            }));
            return;
        }

        if (roles.filter((role) => role.id === 78).length === 0 && roles.filter((role) => parseInt(role.id) === parseInt(GuestRoleUniqId)).length > 0) {
            setNotification((prev) => ({
                ...prev,
                roles: formatted_roles,
                apply_to_observers: false,
                apply_to_guests: true,
            }));
            return;
        }

        if (roles.filter((role) => role.id === 78).length > 0) {
            //support observer
            setNotification((prev) => ({
                ...prev,
                roles: formatted_roles,
                apply_to_observers: true,
            }));
            return;
        }

        if (roles.filter((role) => parseInt(role.id) === parseInt(GuestRoleUniqId)).length > 0) {
            //guest user
            setNotification((prev) => ({
                ...prev,
                roles: formatted_roles,
                apply_to_guests: true,
            }));
            return;
        }

        setNotification((prev) => ({
            ...prev,
            roles: formatted_roles,
            apply_to_guests: false,
            apply_to_observers: false,
        }));
    };

    const onAddRule = () => {
        setNotification((prev) => ({
            ...prev,
            rules: [
                ...prev.rules,
                {
                    type: 0,
                    tpl: 0,
                    args: null,
                    negate: false,
                    idx: prev.rules.length,
                    field: '',
                    op: 0,
                    value: '',
                },
            ],
        }));
    };

    const onUpdateRule = (rule) => {
        console.log(`[onUpdateRule] Updating rule with idx: ${rule.idx}`);
        setNotification((prev) => {
            const newRules = prev.rules.map((r) => {
                if (r.idx === rule.idx) {
                    return rule;
                }
                return r;
            });
            return { ...prev, rules: newRules };
        });
    };

    const onRemoveRule = (idx) => {
        const updatedNotification = { ...notification }; // shallow copy
        updatedNotification.rules.splice(idx, 1); // cut out
        updatedNotification.rules = updatedNotification.rules.map((r, i) => ({ ...r, idx: i })); // deep copy and re-index
        setNotification((prev) => updatedNotification);
    };

    const onAddAdvancedRule = () => {
        setNotification((prev) => ({
            ...prev,
            delivery_method_advanced_rules: [
                ...prev.delivery_method_advanced_rules,
                {
                    trigger_notification_delivery_methods: null,
                    condition: DELIVERY_METHOD_SUCCESSFUL,
                    condition_any_all: CONDITION_ANY,
                    dependent_notification_delivery_methods: null,
                    send_after_min: null,
                    idx: prev.delivery_method_advanced_rules.length,
                },
            ],
        }));
    };

    const onRemoveAdvancedRule = (idx) => {
        setNotification((prev) => {
            let new_idx_advanced_rules = prev.delivery_method_advanced_rules.filter((ur) => ur.idx !== idx);
            if (new_idx_advanced_rules.length > 0) {
                for (let index = 0; index < new_idx_advanced_rules.length; index++) {
                    new_idx_advanced_rules[index].idx = index;
                }
            }
            return { ...prev, delivery_method_advanced_rules: [...new_idx_advanced_rules] };
        });
    };

    const onAccessTagsChange = (ev, atags, reason) => {
        setNotification((prevState) => ({ ...prevState, atag: atags }));
    };

    const onSystemTagsChange = (ev, stags, reason) => {
        setNotification((prevState) => ({ ...prevState, tags: stags }));
    }

    const handleDuplicateNotification = () => {
        if (!window.confirm('Are you sure you want to duplicate this notification?')) {
            return;
        }
        setSyncActive(true);
        (async () => {
            try {
                let formatted_tours = [];
                if (notification?.tours) {
                    formatted_tours = [...notification.tours];
                }

                formatted_tours = formatted_tours?.map((tour) => tour.id);
                const res = await dataAPI(CREATE, resource, {
                    data: {
                        tour_override_mode: notification.tour_override_mode,
                        tours: formatted_tours,
                        enabled: false
                    },
                    urlSuffix: notification.id + '/duplicate/',
                });
                enqueueSnackbar('Notification duplicated', {
                    variant: 'success',
                    action: (key) => (
                        <React.Fragment>
                            <Button
                                onClick={() => {
                                    closeSnackbar(key);
                                    window.location.href = `/notifications/${res.data.id}`;
                                }}
                            >
                                Open it
                            </Button>
                            <Button
                                onClick={() => {
                                    closeSnackbar(key);
                                }}
                            >
                                Dismiss
                            </Button>
                        </React.Fragment>
                    ),
                });
            } catch (e) {
                enqueueSnackbar('Error duplicating notification', { variant: 'error' });
                console.error('Error duplicating notification', e);
            } finally {
                setSyncActive(false);
            }
        })();
    };


    if (!hasPerm('notification', 'read')) {
        <AccessDeniedView />;
    }
    return (
        <FormLicenseeContext.Provider value={toLicenseeId(notification.tour_operator)}>
        <>
            <PageMeta title={isCreate ? 'Create Notification' : `Edit Notification${notification && notification.name ? ' - ' + notification.name : ''}`} />
            <BlockRedirect shouldBlock={isChanged} message="Are you sure you want to leave without saving changes?" />
            {confirmationDialogAction ? (
                <ConfirmationDialog
                    classes={{ paper: classes.paper }}
                    keepMounted
                    onCancel={confirmationDialogCancel}
                    onConfirm={confirmationDialogConfirm}
                    title={ConfirmationDialogText[confirmationDialogAction].title}
                    okButtonText={ConfirmationDialogText[confirmationDialogAction].okButtonText}
                    cancelButtonText={ConfirmationDialogText[confirmationDialogAction].cancelButtonText}
                    open={!!confirmationDialogAction}
                >
                    <Typography>
                            {ConfirmationDialogText[confirmationDialogAction].body}
                            <span style={{ fontWeight: 700 }}>{notification?.name || 'Notification'}</span> This action is irreversible. Are you sure?
                        </Typography>
                </ConfirmationDialog>
            ) : null}

            {openChangeHistory && (
                <Dialog open={openChangeHistory} onClose={(ev) => setOpenChangeHistory(false)} fullWidth={true} maxWidth="xl">
                    <DialogTitle>Change history for notification "{notification.name}"</DialogTitle>
                    <DialogContent>
                        <RevisionHistoryDialog open={openChangeHistory} resource={resource} id={notification.id} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={(ev) => setOpenChangeHistory(false)}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <FixedLinearProgress visibility={syncActive} />
            <Grid container direction="row" className={classes.root}>
                <NavigateBackBar label={notification.name} maxLabelLength={page_title_length} url={backUrl} />
                <Grid
                    item
                    xs={12}
                    container
                    m={isSmallScreen ? 0 : 2}
                    mt={0}
                    style={{
                        border: 'solid 1px #D8D8D8',
                        borderRadius: '12px',
                        padding: '0',
                    }}
                >
                    <Grid item xs={12} sm={3} xl={3} p={2}>
                        <Typography variant="h6"> General settings</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} xl={3} container alignItems="center" justifyContent={!isSmallScreen && 'end'} p={2}>
                        <Grid item xs={4} container alignItems="center" justifyContent={!isSmallScreen && 'end'}>
                            <Button disabled={syncActive} size="small" color="primary" onClick={handleDuplicateNotification}>
                                <FileCopyOutlinedIcon />
                                &nbsp;Duplicate
                            </Button>
                        </Grid>
                        <Grid item xs={8} container alignItems="center" justifyContent="end">
                        <Typography>Status: </Typography>
                        <Typography
                            style={{
                                marginLeft: '1rem',
                                fontWeight: !notification.enabled && 700,
                            }}
                        >
                            OFF
                        </Typography>
                        <Switch
                            disabled={!hasWritePerm}
                            name="enabled"
                            color="primary"
                            checked={notification.enabled}
                            onChange={() => {
                                setNotification((prev) => ({
                                    ...prev,
                                    enabled: !prev.enabled,
                                }));
                            }}
                        />
                        <Typography style={{ fontWeight: notification.enabled && 700 }}>ON</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={false} sm={5} xl={6}></Grid>
                    <Grid item xs={12} sm={7} xl={6} p={2} pb={0}>
                        <LicenseeFormField value={notification.tour_operator} onChange={onLicenseeChange} disabled={!hasWritePerm} allowParent={hasPerm('franchise', 'manager')} />
                    </Grid>
                    {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}
                    <Grid item xs={12} sm={7} xl={6} p={2}>
                        <TextField
                            disabled={!hasWritePerm}
                            name="name"
                            label="Title:"
                            value={notification.name || ''}
                            variant="filled"
                            fullWidth
                            onChange={(ev) =>
                                setNotification((prev) => ({
                                    ...prev,
                                    name: ev.target.value,
                                }))
                            }
                        />
                    </Grid>
                    {!isSmallScreen && <Grid item  sm={5} xl={6}></Grid>}
                    <Grid item xs={12} sm={7} xl={6} p={2} pt={0}>
                        {customEvent ? (
                            <TextField disabled={!hasWritePerm} name="event" label="Upon which event:" variant="filled" value={notification.event} onChange={onTextChange} fullWidth />
                        ) : (
                                <Autocomplete
                                    disabled={!hasWritePerm}
                                    options={eventOptions}
                                    getOptionLabel={(option) => option.label}
                                    onChange={(event, value) => onSelectChange({ target: { name: 'event', value: value ? value.value : '' } })}
                                    value={eventOptions.find((opt) => opt.value === notification.event) || null}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Upon which event"
                                            variant="filled"
                                            size="small"
                                        />
                                    )}
                                />
                        )}
                        {isAdmin ? <FormControlLabel disabled={!hasWritePerm} control={<Checkbox checked={customEvent} onChange={(ev) => setCustomEvent(ev.target.checked)} />} label="Specify custom event" /> : null}
                    </Grid>
                    {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}
                    <Grid item xs={12} sm={7} xl={6} p={2} pt={0}>
                        <AccessTagsDropdown disabled={!hasWritePerm} value={notification.atag} onChange={onAccessTagsChange} />
                    </Grid>
                    {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}

                    <Grid item xs={12} sm={7} xl={6} p={2} pt={0}>
                        <SystemTagsDropdown disabled={!hasWritePerm} value={notification.tags} onChange={onSystemTagsChange} />
                    </Grid>
                    {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}

                    <Grid item xs={12} sm={7} xl={6} p={2} pt={0}>
                        <FormControl fullWidth variant="filled" disabled={!hasWritePerm}>
                            <InputLabel id="override_mode">Tour Override Mode</InputLabel>
                            <Select disabled={true} name="tour_override_mode" labelId="override_mode" id="override_mode" value={notification.tour_override_mode} onChange={onSelectChange}>
                                <MenuItem value={0}>Non Overridable</MenuItem>
                                <MenuItem value={1}>Overridable</MenuItem>
                                <MenuItem value={2}>Tour Specific</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}
                    <Grid item xs={12} sm={7} xl={6} p={2} pt={0}>
                        <Autocomplete
                            filterSelectedOptions
                            disabled={!hasWritePerm}
                            options={role_options}
                            getOptionLabel={(option) => option?.name}
                            size="large"
                            multiple={true}
                            onChange={handleRolesChange}
                            value={notification.roles.map((role) => role_map[role])}
                            renderInput={(params) => <TextField {...params} variant="filled" color="primary" label="Notification triggered by:" />}
                        />
                    </Grid>
                    {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}
                    { (isTourParticipantEvent || isOrderEvent) && <>
                        <Grid item xs={12} sm={7} xl={6} p={2} pt={0}>
                            <FormControl fullWidth variant="filled" disabled={!hasWritePerm}>
                                <InputLabel id="override_mode">Booking state</InputLabel>
                                <Select name="booking_state" labelId="booking_state" id="booking_state" value={notification.booking_state} onChange={onSelectChange}>
                                    { bookingStatesMenuItems }
                                </Select>
                            </FormControl>
                        </Grid>
                        {!isSmallScreen && <Grid item sm={5} xl={6}></Grid>}
                    </> }
                    <Grid item xs={12} sm={7} xl={6} p={2} pt={0} container direction="row" spacing={2} alignItems="center">
                        <Grid item xs={2}>
                            <Switch
                                disabled={!hasWritePerm}
                                name="lock_delivery"
                                color="primary"
                                checked={notification.lock_delivery === LOCK_USER}
                                onChange={() => {
                                    setNotification((prev) => ({
                                        ...prev,
                                        lock_delivery: prev.lock_delivery === LOCK_USER ? LOCK_NONE : LOCK_USER,
                                    }));
                                }}
                            />
                        </Grid>
                        <Grid item xs={10} container alignItems="center">
                            Block delivery to the same user for <TextField
                                disabled={!hasWritePerm || notification.lock_delivery !== LOCK_USER}
                                sx={{ marginLeft: theme.spacing(2)}}
                                name="lock_time"
                                label="Lock time (seconds)"
                                value={+notification.lock_time}
                                variant="filled"
                                size="small"
                                onChange={(ev) =>
                                    setNotification((prev) => ({
                                        ...prev,
                                        lock_time: +ev.target.value,
                                    }))
                                }
                            />
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={10}>
                            <Typography variant="body2">If enabled, this notification will be delivered to the same user only once within each <strong>{notification.lock_time}</strong> s period. Other deliveries will be logged as rejected.</Typography>
                        </Grid>
                    </Grid>
                    {notification.tour_override_mode === 2 && (
                        <>
                            <Grid item xs={12} sm={7} xl={6} pl={2} pr={2} pb={2}>
                                <RemoteAutocomplete
                                    filterSelected
                                    filterOptions={(options) => options}
                                    disabled={!hasWritePerm}
                                    resource="tour"
                                    label="Tour"
                                    multiple
                                    variant="filled"
                                    size="small"
                                    onChange={(ev, tours) => setNotification((prev) => ({ ...prev, tours: tours }))}
                                    value={notification.tours}
                                    getOptionLabel={(opt) => {
                                        if (opt.is_bespoke) {
                                            return '[id:' + opt.id + '] ' + opt.name + ' (' + opt.start_date + ' - ' + opt.end_date + ')';
                                        }
                                        return '[id:' + opt.id + '] ' + opt.name + ' (Recurring)';
                                    }}
                                    renderOption={(props, option) => {
                                        if (option.is_bespoke) {
                                            return (
                                                <div {...props}>
                                                    [id:{option.id}] {option.name} ({option.start_date} - {option.end_date})
                                                </div>
                                            );
                                        }
                                        return (
                                            <div {...props}>
                                                [id:{option.id}] {option.name} (Recurring)
                                            </div>
                                        );
                                    }}
                                />
                            </Grid>
                            {!isSmallScreen && (
                                <Grid item sm={5} xl={6}>
                                </Grid>
                            )}
                        </>
                    )}

                    <Grid item xs={12} pl={2} pt={2}>
                        <Typography fontWeight={500}>Notification Rules</Typography>
                    </Grid>
                    {notification.rules?.sort(compareIdx).map((rule) => {
                        return (
                            <Grid item xs={12} container alignItems="center" p={2} key={rule.idx}>
                                <NotificationRule
                                  disabled={!hasWritePerm}
                                  data={rule}
                                  issues={issuesForRule(rule.idx, ruleIssues.byIdx, shownServerRuleErrors)}
                                  disableDeleteButton={notification.rules.filter((ur) => ur.created).length > 0 && !rule.created}
                                  setNotification={setNotification}
                                  onUpdateRule={onUpdateRule}
                                  handleRemoveRule={onRemoveRule}
                                  isSmallScreen={isSmallScreen}
                                />
                            </Grid>
                        );
                    })}
                    {notification.rules && notification.rules.length >= 2 ? (
                        <Grid item xs={12} md={6} xl={8} container alignItems="center" justifyContent={!isSmallScreen && 'flex-start'} p={!isSmallScreen && 2} style={{ paddingTop: 0 }}>
                            <Typography style={{ marginLeft: '1rem', fontWeight: (notification.rules_match_type === RULES_MATCH_ALL || !notification.rules_match_type) && 700 }}>Match All</Typography>
                            <Switch
                                disabled={!hasWritePerm}
                                name="rules_match_type"
                                color="primary"
                                checked={notification.rules_match_type === RULES_MATCH_ANY}
                                sx={{
                                    '&.MuiSwitch-root .MuiSwitch-switchBase': {
                                        color: 'lightblue',
                                    },
                                    '& .MuiSwitch-switchBase+.MuiSwitch-track': {
                                        backgroundColor: 'lightblue',
                                    },

                                    '&.MuiSwitch-root .Mui-checked': {
                                        color: 'lightblue',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                                        backgroundColor: 'lightblue',
                                    },
                                }}
                                onChange={() => {
                                    setNotification((prev) => ({
                                        ...prev,
                                        rules_match_type: prev.rules_match_type === RULES_MATCH_ALL || !prev.rules_match_type ? RULES_MATCH_ANY : RULES_MATCH_ALL,
                                    }));
                                }}
                            />
                            <Typography style={{ fontWeight: notification.rules_match_type === RULES_MATCH_ANY && 700 }}>Match Any</Typography>
                        </Grid>
                    ) : (
                        ''
                    )}
                    <Grid item xs={12} container justifyContent="flex-start" m={2} mt={0}>
                        <Button disabled={!hasWritePerm} onClick={onAddRule} variant="outlined" color="primary">
                            <AddIcon fontSize="small"/>&nbsp;Add rule
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} container style={{ padding: '1rem' }}>
                        <div
                            onClick={() => setShowAdvancedSettings((prev) => !prev)}
                            style={{
                                cursor: 'pointer',
                                display: 'flex',
                                gap: '0.5rem',
                                alignContent: 'center',
                            }}
                        >
                            {showAdvancedSettings ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            <Typography sx={{ fontWeight: '500' }}>Advanced Settings</Typography>
                        </div>
                    </Grid>
                    {showAdvancedSettings && (
                        <Grid item xs={12} container direction="row" p={2} spacing={1}>
                            {notification.user_reactions?.sort(compareIdx).map((ur) => {
                                return (
                                    <Grid item xs={12} container alignItems="center" key={ur.idx}>
                                        <UserReaction disabled={!hasWritePerm} data={ur} disableDeleteButton={notification.user_reactions.filter((ur) => ur.created).length > 0 && !ur.created} setNotification={setNotification} handleRemoveReaction={handleRemoveReaction} isSmallScreen={isSmallScreen} />
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12} container justifyContent="flex-start">
                                <Button disabled={!hasWritePerm} onClick={handleAddReaction} variant="outlined" color="primary">
                                    <AddIcon fontSize="small"/>&nbsp;Add reaction
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <ResponseHandler
                                disabled={!hasWritePerm}
                                notification={notification}
                                setNotification={setNotification}
                                isSmallScreen={isSmallScreen}
                                errors={errors}
                            />
                        </Grid>
                    )}
                </Grid>
                {/* Bottom section */}
                <DeliveryMethodList disabled={!hasWritePerm} notification={notification} setNotification={setNotification} relatedLoading={relatedLoading} handleSave={handleSave} />
                {notification.delivery_method_ordering === DELIVERY_ADVANCED && notification.delivery_method_advanced_rules?.sort(compareIdx).map((rule) => {
                    return (
                        <Grid item xs={12} container alignItems="center" p={2} key={rule.idx}>
                            <NotificationAdvancedRule
                                disabled={!hasWritePerm}
                                data={rule}
                                disableDeleteButton={notification.rules.filter((ur) => ur.created).length > 0 && !rule.created}
                                setNotification={setNotification}
                                handleRemoveAdvancedRule={onRemoveAdvancedRule}
                                isSmallScreen={isSmallScreen}
                                deliveryMethods={isAdmin ? notification.delivery_methods : notification.delivery_methods.filter((dm) => NON_ADMIN_DELIVERY_METHODS.indexOf(dm.method) >= 0)}
                            />
                        </Grid>
                    );
                })}
                <Grid style={{visibility: notification.delivery_method_ordering === DELIVERY_ADVANCED ? null : "hidden", height: notification.delivery_method_ordering === DELIVERY_ADVANCED ? null : "5px"}} item xs={12} container justifyContent="flex-start" m={2} mt={0}>
                    <Button disabled={!hasWritePerm} onClick={onAddAdvancedRule} variant="outlined" color="primary">
                        <AddIcon fontSize="small"/>&nbsp;Add advanced rule
                    </Button>
                </Grid>
                <Grid item style={{marginLeft: !isSmallScreen ? "1rem" : null}} xs={12} lg={4.75} container alignItems="center" pl={isSmallScreen && 2}>
                    <Typography style={{paddingRight: isSmallScreen ? "25%" : null}}>Ignore user notification preferences: </Typography>
                    <Typography
                        style={{
                            marginLeft: !isSmallScreen ? "1rem" : null,
                            fontWeight: !notification.ignore_user_nf_prefs && 700,
                        }}
                    >
                        OFF
                    </Typography>
                    <Switch
                        disabled={!hasWritePerm}
                        name="ignore_user_nf_prefs"
                        color="primary"
                        checked={notification.ignore_user_nf_prefs}
                        onChange={() => {
                            setNotification((prev) => ({
                                ...prev,
                                ignore_user_nf_prefs: !prev.ignore_user_nf_prefs,
                            }));
                        }}
                    />
                    <Typography style={{ fontWeight: notification.ignore_user_nf_prefs && 700 }}>ON</Typography>
                </Grid>
            </Grid>
            <div className={classes.buttonPanel}>
                {/* <Button variant="contained" color="primary" onClick={(ev) => setOpenChangeHistory(true)}>
                    {isSmallScreen ? 'CH' : 'View change history'}
                </Button> */}

                <FormActionButtons
                    mode="edit"
                    sx={{ flex: 1 }}
                    onSubmit={() => handleSave()}
                    submitDisabled={!hasWritePerm || !canSave || !isChanged}
                    onCancel={handleCancel}
                    cancelDisabled={syncActive}
                    onDelete={handleDelete}
                    deletePerm="notification.delete"
                    deleteDisabled={!canSave}
                />
            </div>
        </>
        </FormLicenseeContext.Provider>
    );
};

const NotificationEdit = (props) => {
    const resource = 'notification';
    const routeParams = useParams();
    const id = routeParams.id;
    const { hasPerm } = React.useContext(ContextStore);


    if (!hasPerm(resource, 'read')) {
        return <AccessDeniedView />
    }
    return (
        <RecordDetails resource={resource} id={id} fullResponse>
            <RecordDetailsContext.Consumer>{(res) => (res.statusCode === 200 ? <NotificationEditForm {...props} resource={resource} id={id} data={res.data} /> : <NotificationLoading {...props} resource={resource} id={id} res={res} />)}</RecordDetailsContext.Consumer>
        </RecordDetails>
    );
};

export default NotificationEdit;
